import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKey = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M2.586 17.4142C2.2109 17.7891 2.00011 18.2978 2 18.8282V21.0002C2 21.2654 2.10536 21.5197 2.29289 21.7073C2.48043 21.8948 2.73478 22.0002 3 22.0002H6C6.26522 22.0002 6.51957 21.8948 6.70711 21.7073C6.89464 21.5197 7 21.2654 7 21.0002V20.0002C7 19.7349 7.10536 19.4806 7.29289 19.2931C7.48043 19.1055 7.73478 19.0002 8 19.0002H9C9.26522 19.0002 9.51957 18.8948 9.70711 18.7073C9.89464 18.5197 10 18.2654 10 18.0002V17.0002C10 16.7349 10.1054 16.4806 10.2929 16.2931C10.4804 16.1055 10.7348 16.0002 11 16.0002H11.172C11.7024 16 12.211 15.7893 12.586 15.4142L13.4 14.6002C14.7898 15.0843 16.3028 15.0825 17.6915 14.5949C19.0801 14.1074 20.2622 13.163 21.0444 11.9163C21.8265 10.6696 22.1624 9.19433 21.9971 7.7319C21.8318 6.26946 21.1751 4.90641 20.1344 3.86573C19.0937 2.82505 17.7307 2.16834 16.2683 2.00305C14.8058 1.83776 13.3306 2.17366 12.0839 2.9558C10.8372 3.73795 9.89279 4.92003 9.40525 6.30868C8.91771 7.69733 8.91585 9.21033 9.4 10.6002L2.586 17.4142Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M16.5 8C16.7761 8 17 7.77614 17 7.5C17 7.22386 16.7761 7 16.5 7C16.2239 7 16 7.22386 16 7.5C16 7.77614 16.2239 8 16.5 8Z",
		fill: "currentColor",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgKey;
